import { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP Interceptor that automatically adds withCredentials: true to all outgoing HTTP requests.
 * This ensures cookies and authentication credentials are sent with every request.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  // Clone the request and add withCredentials: true to all requests
  const credentialsReq = req.clone({
    withCredentials: true
  });

  // Pass the modified request to the next handler
  return next(credentialsReq);
};
